import { createSimpleFunctional } from '@/util'

export const VBreadcrumbsDivider = createSimpleFunctional('v-breadcrumbs-divider', 'li')
